import { Payer } from "../model";

export class PayerSaveCommand{
    payer: Payer

    constructor(payer: Payer){
        this.payer = payer;
    }
}